import { PButton, PCheckbox, PInlineNotification } from "@porsche-design-system/components-react"
import type { CheckboxChangeEventDetail } from "@porsche-design-system/components-react"
import { useCallback } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { formMessages } from "src/common/form.messages"
import type {
	ColorPickerFieldProps,
	ColorRadioButtonGroupProps,
	InputFieldProps,
	SelectFieldProps,
} from "src/components"
import {
	ButtonGroup,
	FormLayout,
	FormLayoutGroup,
	ColorPickerField,
	ColorRadioGroupField,
	InputField,
	SelectField,
} from "src/components"
import { messages } from "../useCustomInterior"

export interface CustomInteriorColorProps {
	cockpitColorHexCode: ColorPickerFieldProps
	differentCockpitColor: {
		label: string
		onChange: (value: boolean) => void
		value: boolean
	}
	hasSubmitFailed: boolean
	isSubmitting: boolean
	material: SelectFieldProps
	name: InputFieldProps[]
	seatColorHexCode: ColorPickerFieldProps
	setHasSubmitFailed: (value: boolean) => void
	showCatalogInteriorContainer: () => void
	tag: ColorRadioButtonGroupProps
}

export const CustomInteriorColor = ({
	cockpitColorHexCode,
	differentCockpitColor,
	hasSubmitFailed,
	isSubmitting,
	material,
	name,
	seatColorHexCode,
	setHasSubmitFailed,
	showCatalogInteriorContainer,
	tag,
}: CustomInteriorColorProps) => {
	const { formatMessage } = useIntl()

	const onCockpitColorChange = useCallback(
		(e: CustomEvent<CheckboxChangeEventDetail>) =>
			differentCockpitColor.onChange((e.target as HTMLInputElement).checked),
		[differentCockpitColor],
	)

	return (
		<FormLayoutGroup>
			<FormLayout>
				{name.map((props, index) => (
					<InputField key={index} {...props} />
				))}
			</FormLayout>
			<ColorRadioGroupField {...tag} />
			<FormLayout>
				<ColorPickerField {...seatColorHexCode} />
				<PCheckbox
					label={formatMessage(messages.setDifferentCockpitColor)}
					checked={differentCockpitColor.value}
					onChange={onCockpitColorChange}
				/>
				{differentCockpitColor.value && <ColorPickerField {...cockpitColorHexCode} />}
			</FormLayout>
			<SelectField {...material} />
			{hasSubmitFailed && (
				<PInlineNotification
					state="error"
					description={formatMessage(formMessages.errorGeneral)}
					onDismiss={() => setHasSubmitFailed(false)}
				/>
			)}

			<ButtonGroup withoutMarginTop>
				<PButton type="submit" loading={isSubmitting}>
					<FormattedMessage {...formMessages.save} />
				</PButton>
				<PButton type="button" variant="secondary" onClick={showCatalogInteriorContainer}>
					<FormattedMessage {...messages.selectCatalogInterior} />
				</PButton>
			</ButtonGroup>
		</FormLayoutGroup>
	)
}
